import {
  _getSlideStream,
  _getSlideStreamThumbNail,
} from "services/Slides/slidesServices";
import { baseUrl } from "./baseUrl";

export const imageStream = async (
  id,
  isThumbNail = false,
  width = 100,
  height = 100,
  publicationId,
  eventId
) => {
  try {
    const response = isThumbNail
      ? await _getSlideStreamThumbNail(
          id,
          width,
          height,
          publicationId,
          eventId
        )
      : await _getSlideStream(id, publicationId, eventId);

    if (response && response.data) {
      // const blob = isAudio
      //   ? new Blob([response.data], { type: "audio/*" })
      //   : response.data;

      //const blob = new Blob([response.data], { type: "audio/*" });
      const url = URL.createObjectURL(response.data);
      return url;
    } else {
      console.error("Response does not contain data");
    }
  } catch (error) {
    console.error("Failed to fetch image:", error);
    // if (
    //   currentUrl?.includes("viewer-mode/") ||
    //   currentUrl.includes("/active-presentation")
    // ) {
    //   throw error;
    // }
  }
};

export const imageStreamPublic = async (id) => {
  try {
    const response = await _getSlideStream(id);

    if (response && response.data) {
      const url = URL.createObjectURL(response.data);
      return url;
    } else {
      console.error("Response does not contain data");
    }
  } catch (error) {
    console.error("Failed to fetch image:", error);
  }
};

export const imageStreamURL = (documentId) =>
  `${baseUrl}/Document/stream/public/${documentId}`;
export const videoStreamURL = (documentId) =>
  `${baseUrl}/Document/video/stream/${documentId}`;

// /**
//  * Fetch and cache video as blob URL
//  * Similar to imageStream but for videos
//  *
//  * @param {string} id - Document ID for the video
//  * @param {boolean} isThumbNail - Not used for videos, kept for API consistency
//  * @returns {Promise<string>} - Blob URL for the video
//  */
// export const videoStream = async (id, isThumbNail = false) => {
//   try {
//     // Fetch video using the same service as images (both use Document/stream endpoint)
//     // Videos are stored as documents, just with video MIME types
//     const response = await _getSlideStream(id);

//     if (response && response.data) {
//       // Create blob URL from video data
//       // Browser will handle it as video based on MIME type
//       const url = URL.createObjectURL(response.data);
//       return url;
//     } else {
//       console.error('Response does not contain video data');
//     }
//   } catch (error) {
//     console.error('Failed to fetch video:', error);
//     throw error; // Throw so cache can handle the error
//   }
// };
